<template>
    <div class="industrySecondPageWarp">
        <div class="menubox">
            <NavMenu @memberAudit='memberAuditFn' />
        </div>
        <div class="commoncrumbsBox">
            <img :src="img2" class="topimgbox" v-if='memberAudit==1' />
			<img :src="img1" class="topimgbox" v-else />
            <div class="pagetopbox">
                <div class="crumbsBox">
                    <div>
                        您当前所在位置：{{currentMenu?currentMenu:'首页'}}-{{tabactiveTitle}}
                    </div>
                </div>
            </div>
        </div>
        <div class="typeArae">
            <div class="contentWarp">
                <div class="tabsWarp">
                    <router-link v-for="(item,index) in tabsList" :key="index" class="tabItemBox" active-class="nav-link" :to="item.url" @click.native="jump(item)">
                        <span :class="tabactiveTitle==item.name?'activetext':'text'">{{item.name}}</span>
                    </router-link>
                </div>
                <div class="componentBox">
                    <router-view />
                </div>
            </div>
        </div>
        <div class="footerbox">
            <Footer/>
        </div>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            img1: require("@/assets/imgs/member/img1.png"),
			img2: require("@/assets/imgs/member/img2.png"),
            tabsList: [
                { name: '会员名录', url: "/member-secondpage/member" },
                { name: '会员风采', url: "/member-secondpage/member-style" },
                { name: '赋能会员', url: "/member-secondpage/energize-member" },
            ],
            tabactiveTitle: '会员名录',
            memberAudit:'',
            currentMenu:sessionStorage.getItem('clickMenu')
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.tabactiveTitle = val.meta.title
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        //  if (JSON.parse(sessionStorage.getItem('userInfo'))) {
        //     this.memberAudit = JSON.parse(sessionStorage.getItem('userInfo')).memberAudit
        // }
    },
    methods: {
        // 获取会员状态
		memberAuditFn(val){
			this.memberAudit=val
		},
        jump(item) {
            this.tabactiveTitle = item.name;
            sessionStorage.removeItem('currentNew')
            sessionStorage.removeItem('childMenuObj')
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.industrySecondPageWarp {
	width: 100%;
	.menubox {
		width: 100%;
	}
	.commoncrumbsBox {
		width: 100%;
		position: relative;
		.topimgbox {
			width: 100%;
			// height: 300px;
		}
		.pagetopbox {
			width: 100%;
			margin: 0 auto;
			background: rgba(51, 51, 51, 0.23);
			box-sizing: border-box;
			position: absolute;
			bottom: 5px;
			left: 0px;
			.crumbsBox {
				width: 1200px;
				margin: 0 auto;
				padding: 20px 0 20px 0px;
				color: #fff;
			}
		}
	}
	.contentWarp {
		width: 1200px;
		min-height: 400px;
		margin: 0 auto;
		.componentBox {
			margin: 40px 0 0px 0;
		}
	}
}
</style>


